var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 439,
    height: 285,
    viewBox: "0 0 439 285",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3711 247.806L64.2409 245.125V239.02L29.3711 247.806Z",
    fill: "url(#paint0_radial_5097_7922)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M106.941 284.234L438.999 254.145V217.25H213.24V234.421L106.941 284.234Z",
    fill: "url(#paint1_linear_5097_7922)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2409 175.944V239.019L44.1625 244.078L32.883 246.92C32.8345 246.934 32.7851 246.943 32.7351 246.948C31.6211 247.22 29.3703 247.805 29.3703 247.805C28.401 246.63 27.2946 245.587 26.0771 244.699L16.2637 236.355L29.3669 226.032V175.227L64.2409 175.944Z",
    fill: "#BFBFBF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2425 67.3488V117.691L29.4641 126.764V98.7273L17.1055 70.325L25.5788 59.2311C27.0211 57.7612 28.3225 56.1478 29.4644 54.4141C29.4644 54.4141 32.2666 55.4604 33.6156 55.9599L39.3336 58.0851L64.2425 67.3488Z",
    fill: "#BFBFBF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M210.374 202.243L209.829 204.305L149.621 213.334V201.528L180.509 196.16L204.739 198.185L210.44 198.658C210.458 198.656 210.475 198.66 210.492 198.667C211.014 198.712 213.242 198.897 213.242 198.897C213.242 198.897 210.374 201.153 210.374 202.243Z",
    fill: "#BFBFBF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M209.886 94.2927L211.964 99.8396C212.195 101.136 212.627 102.385 213.242 103.537C213.242 103.537 210.649 103.988 209.769 104.151C209.766 104.155 209.762 104.158 209.757 104.159C209.753 104.161 209.748 104.161 209.743 104.161L197.689 106.313L180.431 109.401L149.621 98.0938V72.2734L168.255 81.4281L209.886 94.2927Z",
    fill: "#BFBFBF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M149.617 72.2685V213.339L213.25 198.9V234.419L111.139 282.281C110.455 282.616 109.409 283.106 108.533 283.507C107.658 283.908 106.953 284.242 106.953 284.242V1.03125L213.249 74.3185V103.531L149.617 72.2685Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M106.877 0.957031L64.2387 30.6663V117.689L29.4628 126.762V54.4151L0.644531 74.3335V234.418L29.371 247.805V175.227L64.2387 175.942V263.911L106.943 284.233L106.877 0.957031Z",
    fill: "#1A1A1A"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_5097_7922",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8063 243.412) scale(52.3147 54.5915)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27263
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85622,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_5097_7922",
    x1: 55.33,
    y1: 249.856,
    x2: 444.467,
    y2: 249.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.04469,
    stopColor: "#737373"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.848396,
    stopColor: "white",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.dd1afadae068db7aabbde148ac4ff044.svg";
export { ForwardRef as ReactComponent };